import { Metadata } from "@dropbox/dash-component-library";
import { Text } from "@dropbox/dig-components/typography";
import { Stack } from "@dropbox/dig-foundations";
import { getInitials } from "@mirage/shared/account";
import { getTimeAgoString } from "@mirage/shared/util/time";

import { DashStackIcon } from "@mirage/mosaics/DCLWrappers/DashStackIcon";
import useDropboxAccount from "@mirage/service-auth/useDropboxAccount";
import type { WorkflowAgent } from "@mirage/service-conversation/types";
import i18n from "@mirage/translations";

export const WorkflowAgentMessageHeader = ({
  agent,
}: {
  agent: WorkflowAgent;
}) => {
  const creator = agent.createdBy || {
    display_name: "Unknown",
    profile_photo_url: undefined,
    email: "unknown",
  };
  const currentAccount = useDropboxAccount();
  const isCreator = currentAccount?.email === creator.email;

  return (
    <Stack display="flex" align="center" gap="Macro Small">
      <DashStackIcon
        colorIndex={parseInt(agent.theme as string, 10)}
        emoji={agent.icon}
        size="xlarge"
      />
      <Stack display="flex" align="center">
        <Text isBold size="xlarge">
          {agent.name}
        </Text>
        <Metadata>
          <Metadata.Item>
            <Metadata.Avatar src={creator.profile_photo_url}>
              <Metadata.Label>
                {getInitials(creator.display_name)}
              </Metadata.Label>
            </Metadata.Avatar>
            <Metadata.Label>
              {isCreator
                ? i18n.t("created_by_you")
                : i18n.t("created_by", { name: creator.display_name })}
            </Metadata.Label>
          </Metadata.Item>
          <Metadata.Item>
            <Metadata.Label>
              {getTimeAgoString(agent.createdAtMs)}
            </Metadata.Label>
          </Metadata.Item>
        </Metadata>
      </Stack>
    </Stack>
  );
};
